/// <reference path="GAdmBase.ts"/>

namespace Gordic.Adm.WebControls {
    export abstract class GAdmSeznamBase extends GAdmBase {
        /// PROPERTY
        /** Hlavní grid pro zobrazení dat */
        grid: JQuery<HTMLElement>;

        /** Content na který se odkazuji */
        cnt: GContent & GAdmSeznamBase;

        /** DataListDescriptor */
        dataListDescription: Gordic.General.ApplicationInterface.GDataListDescription;

        isAuthService: boolean;

        /** Aktuálně vybraný řádek */
        row: any;

        /** Základní nastavení seznamu */ 
        options: IGAdmSeznamOptions;

        /** Filtrační formulář možno rozšířit o další políčka */
        filterForm: Gordic.Forms.Form;

        /** Element pro filter */
        filter: JQuery<HTMLElement>;

        /** View, které obsahuje data */
        view: Gordic.Data.View;

        /** Sidebar */
        sidebar: JQuery<HTMLElement>;

         /** Element pro náhled */
        panelElement: JQuery<HTMLElement>;

        /** Grodformat pro grid i pro náhled */
        gridformat: Gordic.Data.GridFormat;

        /** Filtrační data */
        filterData: any;

        /** Otevření z tabu */
        tabOpen: boolean;

        //srvBase: GContent;

        comparatorCnt: JQuery<HTMLElement>;
        comparator: JQuery<HTMLElement>;
        comparatorBadge: GObservableObject<any>;
        // EXPERIMENT
        testDivComparator: JQuery<HTMLElement>;

        /* Kvůli vlastnostem ukládám icoBase */
        icoBase: string;

        zobrazovatCisloObjektuKey: string = "Global.core.zobrazitCisloObjektu";

        // ABSTRAKTNÍ METODY
        /**
         * Metoda pro otevření detailu
         * @param isNew true - nový záznam, false - editace
         */
        abstract openDetail(data: any | null, isNew: boolean): void;

        /**
         * Přidání do filtračního formuláře uživatelká políčka (výběr aktivity přidán automaticky) 
         */
        abstract createFilterForm(): void;

        /**
         * Nastavení "tvrdého filtru" po načtení seznamu (aktivita dodána automaticky)
         * @param hardfilter objekt pro tvrdý filter
         */
        abstract userhardDefaultFilter(hardfilter: any): any;

        /**
         * samotná úprava dat před aplikováním filteru přidání pevných filterů...
         * @param data objekt filteru
         */
        abstract collectData(data: any): void;

        /**
         * Aplikování filteru na data
         * @param filterData filtrační data
         */
        abstract applydata(filterData: any): void;

        /**
         * Vytvoření akcí uživatelských (nejčastěji vazební akce)
         * */
        abstract createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null;

        /**
         * Kontextové menu nad gridem
         * */
        abstract createContextMenu(): MenuParams[];

        /**
         * Akce při výběru
         * @param obj vybrané objekty
         */
        abstract selectionGridAct(obj: IGGridSelection<any>): void;

        /**
         * Získání sxs pro zobrazení navázaných vlastností
         * */
        abstract getSxs(data: any): IGAdmGridSxs;

        /**
         * Akce při vytvoření objektu (nelze použít konstruktor)
         * */
        abstract create();

        //getSrvBase(): GContent {
        //    if (this.srvBase == undefined || this.srvBase == null)
        //        this.srvBase = this.cnt.createServiceContent("Gordic.Adm.WebControls.GBaseSeznam")
        //    return this.srvBase;
        //}

        /**
         * Vytvoření create base
         * @param this
         * @param options
         */
        createBase(this: GContent & GAdmSeznamBase, options: IGAdmSeznamOptions) {
            this.adddefaultValues(options);
            this.dataListDescription = options.dataListDescriptor;
            this.cnt = this;
            if (this.dataListDescription.data_right?.Read == false)
                this.cnt.dialogs.error("jres:33000167", this.dataListDescription.data_right.ReadReason || "jres:33000168") //RC 33000168 : Nemáte dostatečná oprávnění pro zobrazení dat
            this.create();
            this.gridformat = Gordic.Adm.WebControls.GAdmGridFunctions.createGridFormat(this.dataListDescription, this.options.gridSettings?.columnOrder ?? "", false, this.options.gridSettings?.iconAktivitaColumns ?? [])
            this.cnt.uid = this.options.contentName;
            this.comparatorBadge = new GObservableObject({ value: "0" })
            this.comparatorCnt = $("<div>");
            this.createBaseActions();
            this.createTitle();
            this.createBaseFilterForm();
            this.createSidebar();
            //console.log("{0} - {1}".format(this.options.contentCaption, this.dataListDescription.typ_obj?.toString()))
        }

        private adddefaultValues(options: IGAdmSeznamOptions) {
            this.options = { ...OptionsDefaults, ...options };
            this.options.filterSettings = { ...OptionsDefaults.filterSettings, ...options.filterSettings };
            this.options.gridSettings = { ...OptionsDefaults.gridSettings, ...options.gridSettings };
            this.options.comparatorSettings = { ...OptionsDefaults.comparatorSettings, ...options.comparatorSettings };
        }

        private createBaseActions() {
            this.cnt.actions.addRange({
                actBaseAction: {
                    caption: this.createContentCaptionBase(),
                    //caption: this.options.contentCaption,
                    run: (ev, ctx) => {
                        this.cnt.tryCloseAllSignificants();
                    }
                },
                actOpenDetail: {
                    caption: "jres:32131033",
                    icon: "gi-detail",
                    enabled: this.dataListDescription.data_right?.Read || false,
                    tooltip: this.dataListDescription.data_right?.ReadReason || "",
                    run: (ev, ctx) => {
                        this.openDetailBase(false);
                        
                    }
                },
                actNewDetail: {
                    caption: "jres:32000121",
                    icon: "gi-plus",
                    enabled: this.dataListDescription.data_right?.Create || false,
                    tooltip: this.dataListDescription.data_right?.CreateReason || "",
                    run: (ev, ctx) => {
                        this.openDetailBase(true);
                    }
                },
                actAddToComparison: {
                    caption: "jres:33000169", //RC 33000169 : Přidat do porovnání
                    icon: "fa-balance-scale",
                    tooltip: "jres:33000169", //RC 33000170 : Přidat do porovnání
                    visible: (this.tabOpen == undefined) ? true : false,
                    run: (ev, ctx) => {
                        this.addToBalance();
                    }
                },
                actOpenSeznamAdmVlastnostTypObjektu: {
                    caption: "jres:33000417",
                    tooltip: "jres:33000533", 
                    icon: "fa-expand",
                    run: (ev, ctx) => {
                        this.openSeznamAdmVlastnostTypObjektu();
                    }
                },
                actOpenSeznamAdmVlastnostObecnyObjekt: {
                    caption: "jres:33000412",
                    tooltip: "jres:33000534",
                    icon: "fa-expand",
                    run: (ev, ctx) => {
                        this.openSeznamAdmVlastnostObecnyObjekt();
                    }
                },
                actOpenDialogVyberovaSkupina: {
                    caption: "jres:33000439", //RC 33000439 : Uložit řádky do výběrové skupiny
                    icon: "fa-cubes",
                    run: (ev, ctx) => {
                        this.openDialogVyberovaSkupina();
                    }
                },
                //Hromaddné vázaní obecných objetů a vlastností
                actOpenBaseDialogHromadneVlastnosti: {
                    caption: "jres:33000489", //RC 33000489 : Navázat hromadně
                    tooltip: "jres:33000535", //RC 33000535 : Hromadné přiřazení rozšiřujících vlastností a to vybraným konkrétním záznamům
                    icon: "fa-expand",
                    run: (ev, ctx) => {
                        this.openBaseDialogHromadneVlastnosti();
                    }
                },
                actOpenSeznamOnNewTab: {
                    caption: "jres:33000927", //RC 33000927 : Otevřít seznam na nové záložce
                    icon: "fa-external-link",
                    visible: !this.tabOpen,
                    run: (ev, ctx) => {
                        this.openSeznamOnNewTab();
                    }
                },
                actOpenDetailOnNewTab: {
                    caption: "jres:33000929", //RC 33000929 : Otevřít detail na nové záložce
                    icon: "fa-external-link",
                    visible: !this.tabOpen,
                    run: (ev, ctx) => {
                        this.openDetailOnNewTab();
                    }
                }
            })
            var userActions = this.createActions();
            if (userActions != null)
                this.cnt.actions.addRange(userActions);
        }

        createShareMenuBarActions(): MenuParams[] {
            return [{
                favorite: true, type: "static", caption: "jres:33000928", icon: "fa-share-alt", visible: !this.tabOpen, captionVisible: "never", children: [ //RC 33000928 : Sdílet
                    { action: this.cnt.actions.actOpenSeznamOnNewTab },
                    { action: this.cnt.actions.actOpenDetailOnNewTab }
                ]
            }]
        }

        private createContentCaptionBase(): string {
            var zobrazovatCisloObjektu = this.cnt.globalSettings?.getDef(this.zobrazovatCisloObjektuKey, false);
            if (zobrazovatCisloObjektu) {
                if (zobrazovatCisloObjektu == true)
                    return this.createContentCaption();
            }
            return this.options.contentCaption;
        }

        createContentCaption(): string {
            return "{0} ({1})".format(this.options.contentCaption, this.options.dataListDescriptor.typ_obj?.toString())
        }

        openDialogOrModalWindow(cntInitializer: any, inputParams: any, dialogWidth?: number, dialogHeight?: number) {
            if (this.tabOpen)
                $.content().dialogs.showModalWindow(cntInitializer, inputParams, "", dialogWidth ?? 1000, dialogHeight ?? 600)
            else
                $.content().navigate(cntInitializer, inputParams);
        }

        private createTitle() {
            this.cnt.uid = "seznam{0}".format(this.options.contentName);
            this.cnt.setBreadcrumbs({
                action: this.cnt.actions.actBaseAction
            })
        }

        private createBaseFilterForm() {
            this.filterForm = new Gordic.Forms.Form()
            this.createFilterForm();
            if (this.options.filterSettings?.addDefaultaktivita == true) {
                this.filterForm.addRow("jres:32131030").addField("gselectbox", Gordic.Prefabs.Select.admGincakt(), {
                    name: "aktivita",
                    list: true,
                    itemClass: "spaced",
                    itemWidth: "",
                    model: "model.aktivita=value.aktivita",
                })
            }
        }

        

        private convertAktivita(data): any {
            if (this.options.filterSettings?.addDefaultaktivita == true) {
                if (data.aktivita != null && data.aktivita != undefined) {
                    if (data.aktivita == 0)
                        data.aktivita = 100
                    else
                        data.aktivita = [100, 300, 500, 600, 900]
                }
            }
        }

        

        private createSidebar() {
            if (this.tabOpen == undefined) {
                $(this.cnt.element).gsidebar("removeAll");
                var panels: any[] = [];
                panels.push(this.createPanel());
                if (this.options.comparatorSettings?.addComparator == true)
                    panels.push(this.createComparator());
                this.sidebar = $(this.cnt.element).gsidebar({
                    userSettings: this.cnt.userSettings,
                    right: {
                        pinned: true,
                        panels: panels
                    }
                })
                this.sidebar.addHelpContext("sidebar:info");
            }
        }

        private createComparator(): GSideBarPanelOptions {
            var panel = {
                minWidth: 300,
                icon: "fa-balance-scale",
                id: "comparatorPanel",
                caption: "jres:33000170",
                leaf: { caption: "jres:33000170", badge: this.comparatorBadge },
                open: (ev, obj) => {
                    this.refreshComparator($(ev.target))
                },
            } as GSideBarPanelOptions;
            return panel;
        }

        private createPanel(): GSideBarPanelOptions {
            var panel = {
                icon: "gi-nahled",
                minWidth: 300,
                id: "seznamNahled",
                caption: "jres:32131038",							//RC 32131038 : Náhled
                leaf: "jres:32131038",								//RC 32131038 : Náhled
                open: (ev, obj) => {
                    this.refreshPanel($(ev.target))
                },
            } as GSideBarPanelOptions;
            return panel;
        }

        private refreshComparator(elementPanel: JQuery<HTMLElement>): void  {
            if (elementPanel) {
                if (!this.comparator) {
                    this.comparator = $("<div class='js-detail-comparator'>").appendTo(elementPanel).gautofit({ parentElement: ".g-sbp-content", scrollOnCritical: false }).gcomparator({
                        columns: this.gridformat,
                        items: [],
                        itemTemplate: this.options.comparatorSettings?.itemTemplate,
                        itemchange: (ev, ctx) => {
                            this.comparatorBadge.value = String(ctx.count);
                            this.comparatorBadge.update();
                        },
                        selection: (ev, ctx) => {
                            var obj = {};
                            this.dataListDescription.list_pk_fields?.forEach((item) => {
                                obj[item] = ctx.item[item];
                            })
                            this.grid.ggrid("activeRow", obj)
                        }
                    })
                }
            }
        }

        private addToBalance() {
            var selection = this.grid.ggrid("getSelection", true);
            if (selection.length != 0) {
                var cnt = this.cnt.element.gsidebar("getPanel", "comparatorPanel");
                if (!this.comparator) 
                    this.refreshComparator(cnt);
                this.comparator.gcomparator("addItems", selection.map(function (item, idx) { return item.data; }))
                cnt.gsbpanel("show");
                selection.forEach((item) => { item.checked = false })
                this.grid.ggrid("refresh");
             }
        }

        private refreshPanel(elementPanel?: JQuery<HTMLElement>): void {
            var panel: JQuery<HTMLElement> | undefined;
            if (this.sidebar != undefined)
                panel = this.sidebar.gsidebar("getPanel", "seznamNahled")
            else
                panel = elementPanel;
            if (panel !== undefined) {
                if (this.panelElement !== undefined)
                    this.panelElement.remove();
                this.panelElement = $("<div>").appendTo(panel);
                if (this.row == undefined)
                    GAdmGridFunctions.createPanelData("jres:32131039", this.row, this.gridformat, this.panelElement, this.options.gridSettings); //RC 32131039 : Seznam
                else if (this.row.length > 1)
                    this.panelElement.html(`<br />&nbsp;&nbsp;&nbsp; jres:33000988: <b>${this.row.length}</b>`) //RC 33000988 : Počet vybraných položek
                else
                   GAdmGridFunctions.createPanelData("jres:32131039", this.row, this.gridformat, this.panelElement, this.options.gridSettings); //RC 32131039 : Seznam
            }
        }

        private openDetailBase(newRecord: boolean): any {
            if (newRecord == true) 
                this.openDetail(null, newRecord);
            else {
                var pom = this.grid.ggrid("activeRow");
                if (!pom) {
                    this.cnt.notification("showToast", {
                        title: this.options.contentCaption,
                        content: "jres:33000171", //RC 33000171 : Nevybrán žádný záznam, detail nelze otevřít.
                        state: "error",
                        icon: "fa-times-error",
                    })
                } else {
                    this.openDetail(pom, false);
                }
            }
        }

        /**
         * Přidání sloupce pro platnost (pokud mají data obsahovat dat_od dat_do, lze použít tento uživatelský sloupec)
         * @param data view z ISL
         */
        setPlatnostColumn(data: Data.View) {
            data.process({
                ac: new Gordic.Data.ComputedFieldsProcessor(
                    (rows) => {
                        rows.forEach((row) => {
                            row.data.platnost = GAdmGlobals.CreatePlatnost(row.data);
                        })
                    }
                )
            })
        }

        /** 
         * Vytvoření hlavního gridu 
         * */
        createGrid(parentEl: JQuery<HTMLElement> | null = null) {
            this.gridformat = this.updateGridFormat(this.gridformat);
            this.grid = $("<div>").gautofit({ resizersOnTab: false }).appendTo((parentEl != null) ? parentEl : this.cnt.element).ggrid({
                columns: this.gridformat,
                columnMode: "full",
                defaultAction: this.cnt.actions.actOpenDetail,
                contextMenu: this.createContextMenu(),
                //multi: (this.tabOpen == undefined) ? true : false,
                multi: true,
                rowsCheckEnabled: (row: MetaRow<any>) => {
                    return this.rowsCheckEnabledFunction(row);
                },
                rowsEnabled: (row: MetaRow<any>) => {
                    return this.rowsEnabledFunction(row);
                },
                profiles: this.options.gridSettings?.profiles,
                selection: (ev, ctx) => {
                    this.row = ctx.getSelection();
                    this.refreshPanel();
                    this.cnt.actions.actOpenDetail?.update({ enabled: this.row.length == 1 })
                    this.cnt.actions.actOpenSeznamAdmVlastnostObecnyObjekt?.update({ enabled: this.row.length == 1 })
                    this.cnt.actions.actOpenDialogVyberovaSkupina?.update({ enabled: ctx.count > 0 })
                    this.cnt.actions.actOpenBaseDialogHromadneVlastnosti?.update({ enabled: ctx.count > 0 })
                    this.cnt.actions.actOpenDetailOnNewTab?.update({ enabled: this.row.length == 1 })
                    this.selectionGridAct(ctx);
                },
                defaultProfile: {
                    sort: (this.options.gridSettings?.defaultSort != "") ? this.options.gridSettings?.defaultSort : this.dataListDescription.list_order_fields
                }
            })
        }

        rowsCheckEnabledFunction(row: MetaRow<any>): boolean {
            return true;
        }

        rowsEnabledFunction(row: MetaRow<any>): boolean {
            return true;
        }

        /**
         * Mo6nost upravit gridFormat (odebrat nepotřebné sloupce nebo je aktualizovat)
         * */
        updateGridFormat(gridFormat: Gordic.Data.GridFormat<any>): Gordic.Data.GridFormat<any> {
            return gridFormat;
        }

        /**
         * Vytvoření filteru
         * @param parentEl
         */
        createFilter(parentEl: JQuery<HTMLElement> | null = null) {
            var hardDefaultFilter: any = {};
            hardDefaultFilter = this.userhardDefaultFilter(hardDefaultFilter);
            if (this.options.filterSettings?.addDefaultaktivita == true) {
                hardDefaultFilter.aktivita = 0;
            }
            this.filter = $("<div>").appendTo((parentEl != null) ? parentEl : this.cnt.element).gfilterpanel({
                forms: [this.filterForm],
                hardDefaultFilter: (this.options.filterSettings?.useHardDefaultFilter == true) ? hardDefaultFilter : null,
                favorites: (this.options.filterSettings?.favorites) ? this.options.filterSettings?.favorites : "all",
                poVyhledaniZobrazit: (this.tabOpen == true) ? 'VyhledanePodminkyVBadge' : 'VyhledanePodminkyVSelectboxu',
                collectData: (ev, o) => {
                    this.convertAktivita(o.data);
                    this.collectData(o.data);
                },
                apply: (ev, data: any) => {
                    this.filterData = data.filter;
                    this.applydata(data.filter);
                }
            })
        }

        private openSeznamAdmVlastnostTypObjektu() {
            this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostTypObjektu"], {
                Id: "SeznamAdmVlastnostTypObjektu",
                typ_obj: this.dataListDescription.typ_obj,
                ico: this.icoBase ? this.icoBase : null
            })
        }

        private openSeznamAdmVlastnostObecnyObjekt() {
            var data = this.grid.ggrid("activeRow");
            if (data != null && data != undefined) {
                var sxsObj = this.getSxs(data);
                this.cnt.navigate(["Gordic.Adm.WebControls.SeznamAdmVlastnostObecnyObjekt"], {
                    Id: "SeznamAdmVlastnostObecnyObjekt",
                    typ_obj: this.dataListDescription.typ_obj,
                    ico: this.icoBase ? this.icoBase : null,
                    sxs: sxsObj.sxs,
                    nazev: sxsObj.nazev
                })
            }
        }

        private openDialogVyberovaSkupina() {
            var selectionData = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmVyberovaSkupinaObsahSaveDto[] = [];
            if (selectionData.length > 0) {
                selectionData.forEach((item) => {
                    var sxsObj = this.getSxs(item);
                    data.push({
                        typ_subj: this.dataListDescription.typ_obj,
                        nazev: sxsObj.nazev,
                        sxs_subj: sxsObj.sxs,
                        aktivita: (item["aktivita"]) ? item["aktivita"] : 100,
                        poznamka: "",
                    })
                })
                this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.GAdmVyberovaSkupinaDialog"], { data: data, typ_subj: this.dataListDescription.typ_obj }, "",  600,  300 )
            }
        }

        private openBaseDialogHromadneVlastnosti() {
            var selectionData = this.grid.ggrid("getSelection");
            var data: Gordic.AdmIsl.Interface.GAdmVlastnostObecnyObjektReadDto[] = [];
            if (selectionData.length > 0) {
                selectionData.forEach((item) => {
                    var sxsObj = this.getSxs(item);
                    data.push({
                        typ_obj: this.dataListDescription.typ_obj,
                        nazev: sxsObj.nazev,
                        sxs: sxsObj.sxs,
                    })
                })
            }
            this.cnt.dialogs.showModalWindow(["Gordic.Adm.WebControls.HromadnaOperaceVlastnostObecnyObjekt"], { data: data }, "", 1000, 600)
        }

        private openSeznamOnNewTab() {
            Gordic.WebApp.Utility.openApp(
                null,
                "OpenTaskListAction",
                {
                    name: this.cnt.taskId
                },
                { ticketType: (this.isAuthService == true) ? Gordic.Enums.TicketType.WithLoginAndContext : Gordic.Enums.TicketType.None }
            )
        }

        private openDetailOnNewTab() {
            let activeRow = this.grid.ggrid("activeRow");
            if (activeRow != null && activeRow != undefined) {
                Gordic.WebApp.Utility.openApp(
                    null,
                    "OpenDetail",
                    {
                        sxs: this.getSxs(activeRow).sxs,
                        type: this.dataListDescription.typ_obj
                    },
                    {
                        ticketType: (this.isAuthService == true) ? Gordic.Enums.TicketType.WithLoginAndContext : Gordic.Enums.TicketType.None
                    }
                )
            }
        }

        getAktivitaTxt(aktivita: number): string {
            let aktivita_txt = "";
            switch (aktivita) {
                case 100:
                    aktivita_txt = "jres:33000139"
                    break;
                case 300:
                    aktivita_txt = "jres:33000142"
                    break;
                case 500:
                    aktivita_txt = "jres:33000140"
                    break;
                case 600:
                    aktivita_txt = "jres:33000141"
                    break;
                case 900:
                    aktivita_txt = "jres:33000143"
                    break;
            }
            return aktivita_txt.toLowerCase();
        }

        findColumnIndexByName(name: string): number {
            return this.gridformat.columns.findIndex(item => item.name == name)
        }

        settingGroupingColumn(name: string, open: boolean) {
            const columnIndex = this.findColumnIndexByName(name);
            if (columnIndex != -1)
                this.gridformat.columns[columnIndex].grouping = { defaultState: open == true ? "open" : "closed" };
        }
    }
}